import { ProductObj } from "../../apps/Bundles/Types";

export const filterFreeGifts = (_freeGifts: ProductObj[], parentProducts: ProductObj[]) => {
    if (parentProducts.length) {
        const newTemp = _freeGifts?.filter((tp) => !parentProducts?.some((ep) => ep?.id === tp?.id));
        if (newTemp?.length < _freeGifts?.length) {
            shopify.toast.show("Included product cannot be added as free gift(s)", { isError: true });
            return newTemp?.length > 0 ? { arr: newTemp, isChanged: true } : { arr: [], isChanged: true };
        } else {
            return { arr: newTemp, isChanged: false };
        }
    }
};
